import { render, staticRenderFns } from "./WebPageAppSetting.vue?vue&type=template&id=b8ada914&"
import script from "./WebPageAppSetting.vue?vue&type=script&lang=js&"
export * from "./WebPageAppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports